import { create } from 'zustand';

interface AuthState {
  isAuthenticated: boolean;
  userId: string | null;
  teamId: string | null;
  email: string | null;
  /** Platform administrator, from PLATFORM_ADMINS on the server. */
  isAdmin: boolean;
  loading: boolean;
  /**
   * Whether the session has been checked against the server at least once.
   * This state is global, so without it every component that reads auth would
   * re-check on mount and flip `loading` back on for the whole app.
   */
  initialized: boolean;
  setAuth: (userId: string, teamId: string, email: string, isAdmin: boolean) => void;
  clearAuth: () => void;
  setLoading: (loading: boolean) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  isAuthenticated: false,
  userId: null,
  teamId: null,
  email: null,
  isAdmin: false,
  loading: true,
  initialized: false,
  setAuth: (userId, teamId, email, isAdmin) =>
    set({ isAuthenticated: true, userId, teamId, email, isAdmin, loading: false, initialized: true }),
  clearAuth: () =>
    set({
      isAuthenticated: false,
      userId: null,
      teamId: null,
      email: null,
      isAdmin: false,
      loading: false,
      initialized: true,
    }),
  setLoading: (loading) => set({ loading }),
}));
